// components/Outreach/ExecutionTab.js
import React, { useState, useEffect } from "react";
import { getCookie } from "../../services/cookie";

const API_BASE = "https://flautreach.com/flautreach/api/outreach";

export function ExecutionTab({ add }) {
  const token = () => getCookie("authToken");
  const getHeaders = () => {
    const t = token();
    return { "Content-Type": "application/json", ...(t ? { Authorization: `Bearer ${t}` } : {}) };
  };

  const [workers, setWorkers] = useState([]);
  const [email, setEmail] = useState("");
  const [workerId, setWorkerId] = useState("");
  const [messageText, setMessageText] = useState("");
  const [executions, setExecutions] = useState([]);
  const [creating, setCreating] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => { loadWorkers(); loadExecutions(); }, [page]);

  const loadWorkers = async () => {
    try {
      const resp = await fetch(`${API_BASE}/workers/`, { headers: getHeaders() });
      if (resp.ok) {
        const data = await resp.json();
        setWorkers(Array.isArray(data) ? data : data.results || []);
      }
    } catch {}
  };

  const loadExecutions = async () => {
    try {
      const resp = await fetch(`${API_BASE}/executions/?page=${page}&page_size=10`, { headers: getHeaders() });
      if (resp.ok) {
        const data = await resp.json();
        setExecutions(data.results || data || []);
        setTotalPages(data.pagination?.total_pages || 1);
      }
    } catch {}
  };

  const createExecution = async () => {
    if (!email.trim()) { add?.("Введи email", "error"); return; }
    setCreating(true);
    try {
      const resp = await fetch(`${API_BASE}/executions/create_by_email/`, {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify({
          email: email.trim(),
          worker_id: workerId || null,
          sent_text: messageText.trim() || null,
        }),
      });
      if (resp.ok) {
        const data = await resp.json();
        add?.(`Execution создан! ID: ${data.execution_id}`, "success");
        setEmail("");
        setMessageText("");
        loadExecutions();
      } else {
        const err = await resp.json().catch(() => ({}));
        add?.(err.detail || "Ошибка", "error");
      }
    } catch (err) {
      add?.("Ошибка", "error");
    } finally {
      setCreating(false);
    }
  };

  const deleteExecution = async (id) => {
    if (!window.confirm(`Удалить execution #${id}?`)) return;
    try {
      await fetch(`${API_BASE}/executions/${id}/`, { method: "DELETE", headers: getHeaders() });
      add?.("Execution удалён", "info");
      loadExecutions();
    } catch (err) {
      add?.("Ошибка", "error");
    }
  };

  return (
    <div>
      {/* Форма создания */}
      <div className="section-card" style={{ marginBottom: 20 }}>
        <h3>📤 Создать Outreach Execution вручную</h3>
        <div className="form-group">
          <label className="form-label">Email получателя *</label>
          <input className="form-input" style={{ paddingLeft: 14 }} value={email} onChange={e => setEmail(e.target.value)} placeholder="user@example.com" />
        </div>
        <div className="form-group">
          <label className="form-label">Воркер</label>
          <select className="form-input" style={{ paddingLeft: 14 }} value={workerId} onChange={e => setWorkerId(e.target.value)}>
            <option value="">-- Любой --</option>
            {workers.map(w => (<option key={w.id} value={w.id}>{w.name}</option>))}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Текст сообщения</label>
          <textarea className="intent-textarea" style={{ minHeight: 80 }} value={messageText} onChange={e => setMessageText(e.target.value)} placeholder="Конкретный текст отправленного сообщения..." />
        </div>
        <button className="btn-primary" style={{ width: "auto", padding: "13px 32px" }} disabled={creating} onClick={createExecution}>
          {creating ? "⏳" : "→"} Создать Execution
        </button>
      </div>

      {/* Список */}
      <div className="section-card">
        <h3>Последние executions</h3>
        <div className="rules-grid" style={{ marginTop: 12 }}>
          {executions.map(e => (
            <div key={e.id} className="rule-card" style={{ padding: "14px 18px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <strong>#{e.id}</strong>
                  <span style={{ marginLeft: 10, fontSize: 12, color: "var(--muted)" }}>
                    📧 {e.email || "—"} · 👷 {e.worker_name || "—"} · 📅 {new Date(e.created_at).toLocaleString()}
                  </span>
                  {e.sent_message_text && (
                    <p style={{ fontSize: 12, color: "var(--muted)", marginTop: 4 }}>
                      {(e.sent_message_text || "").substring(0, 80)}...
                    </p>
                  )}
                </div>
                <button className="btn-delete" onClick={() => deleteExecution(e.id)}>🗑</button>
              </div>
            </div>
          ))}
        </div>
        {totalPages > 1 && (
          <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 16 }}>
            <button disabled={page <= 1} onClick={() => setPage(p => p - 1)}>←</button>
            <span>{page} / {totalPages}</span>
            <button disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>→</button>
          </div>
        )}
      </div>
    </div>
  );
}